import {
  FaChartBar,
  FaExchangeAlt,
  FaFireAlt,
  FaGamepad,
  FaGift,
  FaUsers,
} from "react-icons/fa";
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";
import { formatNumber } from "../formatters";

const StatCard = ({ label, value, subtitle = null, highlight = false, icon }) => (
  <div
    className={`leaderboard-stat-card ${
      highlight ? "leaderboard-stat-card-highlight" : ""
    }`}
  >
    <span className="leaderboard-stat-icon" aria-hidden="true">
      {icon}
    </span>
    <div className="leaderboard-stat-copy">
      <span className="leaderboard-stat-label">{label}</span>
      <span className="leaderboard-stat-value">{value}</span>
      {subtitle ? <span className="leaderboard-stat-subtitle">{subtitle}</span> : null}
    </div>
  </div>
);

const DckslapCoreStatsSection = ({ stats, gbofMinted, currentMonthName }) => {
  return (
    <Card className="leaderboard-surface-card">
      <CardHeader className="pb-4">
        <div className="leaderboard-section-header">
          <div className="leaderboard-section-icon">
            <FaChartBar className="h-5 w-5" />
          </div>
          <div>
            <span className="leaderboard-section-kicker">DCKSLAP Stats</span>
            <CardTitle className="text-xl">Core Activity</CardTitle>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="leaderboard-core-grid">
          <StatCard
            icon={<FaFireAlt className="h-3.5 w-3.5" />}
            label="DCKSLAP Minted"
            value={formatNumber(stats.dckslapTotalMinted)}
          />
          <StatCard
            icon={<FaExchangeAlt className="h-3.5 w-3.5" />}
            label="DCKSLAP Transferred"
            value={formatNumber(stats.dckslapTotalTransferred)}
          />
          <StatCard
            icon={<FaGift className="h-3.5 w-3.5" />}
            label="GBOF Minted"
            value={formatNumber(stats.gbofTotalMinted)}
            subtitle={`${formatNumber(gbofMinted)} this ${currentMonthName}`}
            highlight
          />
          <StatCard
            icon={<FaExchangeAlt className="h-3.5 w-3.5" />}
            label="GBOF Transferred"
            value={formatNumber(stats.gbofTotalTransferred)}
          />
          <StatCard
            icon={<FaGamepad className="h-4 w-4" />}
            label="Games Played"
            value={formatNumber(stats.gamesPlayedCount)}
            highlight
          />
          <StatCard
            icon={<FaUsers className="h-3.5 w-3.5" />}
            label="Participants"
            value={formatNumber(stats.totalParticipants)}
          />
        </div>
        <p className="leaderboard-data-hint">
          Counts represent recorded mint, transfer, and gameplay events.
        </p>
      </CardContent>
    </Card>
  );
};

export default DckslapCoreStatsSection;
